import React, { PureComponent } from 'react';

import classNames from 'classnames/bind';
import style from './Slider.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';
import ReactTouchEvents from 'react-touch-events';

const INCREMENT = 2;
const DECREMENT = -2;

const SWIPE_DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};

class Slider extends PureComponent {
  static propTypes = {};
  static defaultProps = {
    articles: [],
  };

  state = {
    currentIdx: 0,
  };

  handleSlide = idx => {
    this.setState({
      currentIdx: idx,
    });
  };

  renderNavigationControls() {
    const { articles } = this.props;

    const { currentIdx } = this.state;

    const max = articles.length - 1;
    const min = 0;

    const disableLeft = currentIdx + DECREMENT < min;
    const disableRight = currentIdx + INCREMENT > max;

    return (
      <div className={ctx('nav')}>
        <span
          className={ctx('nav-item', 'nav-item--left', {
            'nav-item--active': !disableLeft,
          })}
          onClick={
            !disableLeft && this.handleSwipe.bind(null, SWIPE_DIRECTIONS.RIGHT)
          }
        >
          <img
            src={'images/tinyArrowIcon.svg'}
            className={ctx('row-item-svg')}
          />
        </span>
        <span
          className={ctx('nav-item', 'nav-item--right', {
            'nav-item--active': !disableRight,
          })}
          onClick={
            !disableRight && this.handleSwipe.bind(null, SWIPE_DIRECTIONS.LEFT)
          }
        >
          <img
            src={'images/tinyArrowIcon.svg'}
            className={ctx('row-item-svg')}
          />
        </span>
      </div>
    );
  }

  renderRow() {
    const { articles } = this.props;

    const articlesCount = articles.length;
    //ЧИСЛО СТАТЕЙ ЧИТАЙТЕ ТАКЖЕ
    const slideWidthPrecentage = 100 / (articlesCount * 2);

    const { currentIdx } = this.state;

    return (
      <div
        className={ctx('row')}
        style={{
          width: `${100 * articlesCount}%`,
          transform: `translateX(-${slideWidthPrecentage * currentIdx}%)`,
        }}
      >
        {articles.map((article, idx) => (
          <div
            className={ctx('row-item')}
            style={{
              width: `${slideWidthPrecentage}%`,
            }}
            key={idx}
          >
            <Link key={idx} to={article.url} className={ctx('link')}>
              <div
                className={ctx('item')}
                style={{
                  backgroundImage: `url(${article.background})`,
                }}
              >
                <div className={ctx('description')}>
                  {article.title}
                  <div className={ctx('line')} />
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    );
  }

  getNextIdxActive(add) {
    const { currentIdx: active } = this.state;

    const max = this.props.articles.length - 1;
    const min = 0;

    const nextIdx = active + add;

    if (nextIdx < min) {
      return min;
    } else if (nextIdx > max) {
      return max;
    }

    return nextIdx;
  }

  handleTap = () => {
    this.handleSlide(this.getNextIdxActive(INCREMENT));
  };

  handleSwipe = direction => {
    switch (direction) {
      case SWIPE_DIRECTIONS.LEFT:
        {
          this.handleSlide(this.getNextIdxActive(INCREMENT));
        }
        break;
      case SWIPE_DIRECTIONS.RIGHT:
        {
          this.handleSlide(this.getNextIdxActive(DECREMENT));
        }
        break;
    }
  };

  render() {
    return (
      <div className={ctx('more-articles')}>
        <ReactTouchEvents onTap={this.handleTap} onSwipe={this.handleSwipe}>
          <div className={ctx('inner')}>
            {this.renderNavigationControls()}
            <div className={ctx('wrap')}>{this.renderRow()}</div>
          </div>
        </ReactTouchEvents>
      </div>
    );
  }
}

export default Slider;
